import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Dropdown } from '../../ui/components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import Theme from '../../theme';

class DayHeader extends React.Component {
    handleDaySelection = (selectedDay , daysList) => {
        const newSelectedDay = daysList.find(item => item.value === selectedDay);
        this.props.changeDay(newSelectedDay);
    }

    render() {
        const {
            getDays,
            day,
        } = this.props;
        const daysList = getDays().sort((a, b) => a.date - b.date);
        return (
            <View style={styles.dropdownContainer}>
                <Field
                    webAbsolute
                    name="day"
                    hasDate={true}
                    controlFontSize={18}
                    controlFontWeight="bold"
                    showLabel={false}
                    date={day}
                    isRequired={false}
                    valueKey="value"
                    displayKey="display"
                    defaultIndex={-1}
                    options={daysList}
                    defaultValue={day.value}
                    component={Dropdown}
                    rowWidth='95%'
                    onSelect={(selectedDay) => {
                        this.handleDaySelection(selectedDay, daysList);
                    }}
                    controlStyle={{ backgroundColor: Theme.WHITE }}
                />
             </View>
        );
    }
}

DayHeader.propTypes = {
};

const styles = StyleSheet.create({
    dropdownContainer: {
        zIndex: 1,
        paddingHorizontal: 10,
        paddingVertical: 2,
    }
});

DayHeader = translate(['auth', 'formFields'], { wait: true })(DayHeader);
DayHeader = reduxForm({ form: 'dayHeader' })(DayHeader);
DayHeader = connect()(DayHeader);
export default DayHeader;
